module.exports = __webpack_public_path__ + "static/img/compliment.7a0cbe68.svg";